import htmlFormatter from 'html-formatter';

export default html => htmlFormatter.render(html).replace(/\t/g, '  ') + '\n';
